// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.exMXF5KAmYzDae01JpaO{background-color:var(--background-primary-inverted-primary);flex-direction:column;width:100%;height:100vh;display:flex}.jKPywjOyd0YS4BuEwv8N{min-height:540px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `exMXF5KAmYzDae01JpaO`,
	"form": `jKPywjOyd0YS4BuEwv8N`
};
export default ___CSS_LOADER_EXPORT___;
